<template>
    <div class="get-started-steps-container">
        <div v-for="step in steps" :key="step.id" class="step-wrapper">
            <div class="step-content">
                <div class="step-content-header">
                    <div :style="stepNumberStyle(step)" class="step-number">
                        {{ step.id + 1 }}
                    </div>
                    <p :style="stepTitleStyle(step)" class="step-title">
                        {{ step.title }}
                    </p>
                    <img
                        v-if="step.status === status.Complete"
                        :src="URLS.icons.checkmark"
                        class="checkmark"
                        alt="checkmark"
                    />
                </div>
                <p v-if="step.status !== status.Complete" class="step-desc">
                    {{ step.desc }}
                </p>
                <div :style="stepCtaStyle(step)" class="step-cta">
                    <button
                        v-if="step.status !== status.Complete"
                        :style="stepBtnStyle(step)"
                        :disabled="getStartedInfo.disabled"
                        :class="{ 'disabled-btn': getStartedInfo.disabled }"
                        @click="stepRedirect(step)"
                        class="cta-btn"
                    >
                        {{ step.cta }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    const URLS = {
        icons: {
            checkmark: '/images/icons/checkmark-yellow.svg'
        }
    }
    export default {
        name: 'MobileSteps',
        props: {
            steps: {
                type: Array,
                validator: (v) => v.some((s) => s.id && s.title && s.desc && s.status && s.cta)
            },
            status: {
                type: Object
            },
            getStartedInfo: {
                type: Object
            }
        },
        computed: {
            URLS: () => URLS,
            stepNumberStyle: (self) => (step) =>
                step.status === self.status.Complete ? { background: '#464646' } : {},
            stepTitleStyle: (self) => (step) =>
                step.status === self.status.Complete ? { color: '#646464' } : {},
            stepCtaStyle: (self) => (step) =>
                step.status === self.status.Complete ? { 'margin-bottom': '0px' } : {},
            stepBtnStyle: (self) => (step) =>
                step.status === self.status.Current
                    ? { color: 'black', background: '#cdeb09' }
                    : {}
        },
        methods: {
            async stepRedirect(step) {
                localStorage.setItem('getStartedStep', this.getStartedInfo.status)
                if (this.getStartedInfo.bid_artist)
                    localStorage.setItem('bidArtist', this.getStartedInfo.bid_artist)
                if (this.getStartedInfo.bid_id)
                    localStorage.setItem('eventId', this.getStartedInfo.bid_id)
                if (step.status === this.status.Current) {
                    if (this.getStartedInfo.redirect.includes('/event/advance-book-artist')) {
                        await axios.put(
                            '/api/event/' + this.getStartedInfo.bid_id + '/finalize'
                        )
                    }
                    window.location.href = this.getStartedInfo.redirect
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .get-started-steps-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .step-wrapper {
            max-width: 1050px;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            gap: 24px;
            border-radius: 20px;
            padding: 16px;
            background: #262626;

            .step-content {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 16px;

                .step-content-header {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;
                    gap: 8px;

                    .step-number {
                        width: 38px;
                        height: 32px;
                        border-radius: 120px;
                        background: #8b8b8b;
                        color: #333;
                        font-family: 'Instrument Sans';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 6px 0px;
                    }

                    .step-title {
                        color: #acacac;
                        font-family: 'Instrument Sans';
                        font-size: 26px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 120%;
                        letter-spacing: -0.64px;
                    }
                    .checkmark {
                        margin-left: auto;
                    }
                }

                .step-desc {
                    max-width: 600px;
                    color: #acacac;
                    font-family: 'Instrument Sans';
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
                .step-cta {
                    margin-top: 6px;
                    width: 100%;

                    button {
                        display: flex;
                        padding: 11px 30px 12px 30px;
                        justify-content: center;
                        align-items: center;
                        gap: 8px;
                        width: 100%;
                        border-radius: 100px;
                        background: #464646;
                        color: #8b8b8b;
                        font-family: 'Instrument Sans';
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                    }
                    .disabled-btn {
                        background: #464646 !important;
                        color: #8b8b8b !important;
                    }
                }
            }
        }
    }
</style>
